export class ErrorMessage {
    title: string = null;
    message: string = null;
    constructor(title?: string, message?: string) {
        if (title) {
            this.title = title;
        }
        if (message) {
            this.message = message;
        }
    }
    public hasError(): boolean {
        if (this.title != null) {
            return true;
        } else {
            return false;
        }
    }
    public reset(): void {
        this.title = null;
        this.message = null;
    }
}